import React, { useState } from "react";
import { db, storage } from "../../firebase";
import { collection, addDoc, getDocs, serverTimestamp, query, orderBy } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import * as XLSX from "xlsx"; 

function TeacherExcel2() {
  const [isExporting, setIsExporting] = useState(false);

  // 🔹 Updated Export to Excel Function
  const exportToExcel = async () => {
    setIsExporting(true);
    try {
      // 1. Fetch data from Firestore
      const q = query(collection(db, "teacher_from_data"), orderBy("createdAt", "desc"));
      const querySnapshot = await getDocs(q);
      
      const data = querySnapshot.docs.map((doc) => {
        const docData = doc.data();

        // 🛠️ DATE FIX: Convert Firestore Timestamp to Readable String
        let formattedDate = "";
        if (docData.createdAt && docData.createdAt.toDate) {
          // If it's a Firestore Timestamp object
          formattedDate = docData.createdAt.toDate().toLocaleString(); 
        } else if (docData.createdAtDate) {
          // Fallback if you stored it as a string already
          formattedDate = docData.createdAtDate;
        }

        return {
          "Application Date": formattedDate, // Now it will show clearly in Excel
          "Payment ID": docData.paymentId || "",
          "Post Name": docData.postname || "",
          "Applicant Name": docData.name || "",
          "Guardian Name": docData.guardianname || "",
          "Mobile": docData.mobile || "",
          "Email": docData.email || "",
          "Dateofbirth": docData.dateofbirth || "",
          "Gender": docData.gender || "",
          "Category": docData.category || "",
          "Amount Paid": docData.amountPaid || 0,
          "MP Year": docData.mpYear || "",
          "MP %": docData.mpPercentage || "",
          "HS Year": docData.hsYear || "",
          "HS %": docData.hsPercentage || "",
          "Computer Course": docData.computercoursename || "",
          "Yearofpassing": docData.yearofpassing || "",
          "Address": docData.address || "",
          "District": docData.district || "",
          "Pincode": docData.pincode || "",
          "Nearest School Name": docData.nearestschoolname || "",
          "School District Name": docData.schooldistrict || "",
          "Block": docData.block || "",

          "Photo URL": docData.photoURL || "",
          "Signature URL": docData.signatureURL || "",
        };
      });

      if (data.length === 0) {
        alert("No data found to export!");
        return;
      }

      // 2. Create Excel Workbook and Worksheet
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Applications");

      // 3. Download the file
      XLSX.writeFile(workbook, "Teacher_Applications_Data.xlsx");
      
    } catch (error) {
      console.error("Export Error:", error);
      alert("Failed to export data.");
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="album py-4 bg-light">
      <div className="container">
        
        {/* Export Button */}
        <div className="d-flex justify-content-end mb-3">
          <button 
            className="btn btn-success btn-sm shadow-sm" 
            onClick={exportToExcel}
            disabled={isExporting}
          >
            {isExporting ? (
              <>
                <span className="spinner-border spinner-border-sm me-2"></span>
                Generating Excel...
              </>
            ) : (
              "📊 Export All to Excel"
            )}
          </button>
        </div>

        <div className="row justify-content-center">
          <div className="col-md-8">
            <div className="card shadow p-4">
               <h3 className="text-center text-primary mb-4">
                 <b>Teacher Application Form</b>
               </h3>
               
               {/* Rest of your form inputs go here... */}
               <p className="text-center text-muted">
                 Fill out the form below or use the export button above to download existing records.
               </p>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TeacherExcel2;